export const VOICE_COPY_KO = {
  stageHead: '음성 상담',
  introTitle: ['실제 상담처럼 대화하는 Voice AI를', '지금 바로 경험해보세요'],
  introBody:
    'AI 에이전트와 직접 통화하며 문의 응대부터 예약·접수까지, 실제 고객 상담이 어떻게 처리되는지 경험해보세요. 다양한 산업과 상담 시나리오를 직접 체험할 수 있습니다.',
  startCall: '통화 시작',
  connecting: '연결 중…',
  endCall: '통화 종료',
  mute: '음소거',
  unmute: '음소거 해제',
  requestMic: '마이크 권한 요청',
  showExamples: '예시 보기',
  close: '닫기',
  showMore: '더보기',
  collapse: '접기',
  switchScenario: '상담 시나리오 전환',
  startersHeading: '이렇게 시작해보세요',
  callEnded: '통화가 종료되었습니다',
  connectedAnnounce: '통화가 연결되었습니다',
  connectingAnnounce: '연결 중입니다',
  micBlockedTitle: '마이크가 차단되어 있어요',
  micBlockedHint: '주소창에서 허용해주세요',
  micAllowToast: '마이크 권한을 허용해주세요',
  micLive: '마이크가 연결되었어요. 이제 말씀하시면 됩니다.',
  slowConnect: '연결이 지연되고 있어요…',
  reconnecting: '연결 상태가 불안정해요',
  genericError: '일시적인 문제가 발생했어요. 다시 시도해주세요.',
  ipRateLimit: '너무 많이 시도했어요. 잠시 후 다시 시도해주세요.',
  agentRateLimit: '이용자가 많아요. 잠시 후 다시 시도해주세요.',
  maxDuration: '데모 통화 시간이 지나 통화를 종료했어요',
  hiddenEnd: '자리를 비운 동안 통화를 종료했어요',
  otherTab: '다른 탭에서 통화가 시작되어 이 통화를 종료합니다',
  connectingTo: (scenario) => `${scenario.brand} AI 컨시어지에 연결하고 있어요`,
  privacyPolicy: 'Privacy Policy',
  termsOfService: 'Terms of Service',
  privacyUrl:
    'https://sendbird.com/privacy-notice?utm_source=dashboard-staging.delight.ai',
  termsUrl: 'https://sendbird.com/terms',
  disclaimer:
    '*본 데모는 딜라이트 음성 AI의 품질을 확인하기 위한 가상 시나리오로 구성되었으며, 음성 인식과 AI 생성 응답 기반으로 동작합니다. 상품·요금·일정·정책 등 안내되는 모든 정보는 예시 데이터이며, 실제 서비스 안내와 다르거나 부정확한 답변이 있을 수 있습니다. 데모 이용 시 개인정보·민감정보는 입력하지 마시기 바랍니다. 본 데모는 PC환경에서의 사용을 권장합니다.'
}

export default VOICE_COPY_KO
